import React from "react";
import { Routes, Route } from "react-router-dom";
import { Flex, Box, Tooltip, Text, useColorMode, useColorModeValue } from "@chakra-ui/react";
import { Sun, Moon } from "react-feather";
import Launches from "./launches";
import Launch from "./launch";
import Home from "./home";
import LaunchPads from "./launch-pads";
import LaunchPad from "./launch-pad";

import { FavoritesProvider } from "../contexts/favorites-context";
import { UserProvider } from "../contexts/user-context";
import Login  from './login';

export default function App() {
  return (
    <div>
      <UserProvider>
        <FavoritesProvider>
          <NavBar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/launches" element={<Launches />} />
            <Route path="/launches/:launchId" element={<Launch />} />
            <Route path="/launch-pads" element={<LaunchPads />} />
            <Route path="/launch-pads/:launchPadId" element={<LaunchPad />} />
          </Routes>
        </FavoritesProvider>
      </UserProvider>
    </div>
  );
}

function NavBar() {

  const icon  = useColorModeValue(Sun, Moon);
  const tooltipLabel  = useColorModeValue('Light Mode', 'Night Mode');
  const bg  = useColorModeValue('gray.800', 'gray.700');
  
  const { toggleColorMode } = useColorMode();
  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      padding="6"
      bg={bg}  
      color="white"
    >
      <Flex alignItems="center">
        <Text
          fontFamily="mono"
          letterSpacing="2px"
          fontWeight="bold"
          fontSize="lg"
        >
          ¡SPACE·R0CKETS!
        </Text>
        <Tooltip label={tooltipLabel} placement="right">
          <Box 
            as={icon}
            cursor="pointer"
            onClick={toggleColorMode}
            ml={8}
          />  
        </Tooltip>
      </Flex>
      <Login/>
    </Flex>
  );
}
